import classnames from 'classnames';
import React, { forwardRef } from 'react';

import { Icon } from '../icon/Icon';
import { Input, InputProps } from '../input/Input';
import styles from './Select.module.scss';

export interface SelectProps {
  isActive: boolean;
  inputProps: InputProps;
  isReadonlyInput?: boolean;
  className?: string;
}

export const Select = forwardRef<HTMLInputElement, SelectProps>(
  (
    {
      isActive,
      inputProps,
      isReadonlyInput = true,
      className,
      ...rest
    }: SelectProps,
    ref
  ) => {
    return (
      <div className={classnames(styles.root, className)} {...rest}>
        <Input
          data-testid="select-input"
          {...inputProps}
          ref={ref}
          readOnly={isReadonlyInput}
          rightIcon={
            <Icon
              iconName={isActive ? 'ChevronLightUp' : 'ChevronLightDown'}
              size={12}
            />
          }
        />
      </div>
    );
  }
);
